import { render, staticRenderFns } from "./is-hotmart-for-me.vue?vue&type=template&id=09007f22"
import script from "./is-hotmart-for-me.vue?vue&type=script&lang=js"
export * from "./is-hotmart-for-me.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports